import { useEffect } from 'react';
import { AppRouter } from '@/routes/AppRouter';
import { useAuthStore } from '@/shared/stores/auth.store';
import { setUnauthorizedHandler } from '@/shared/api/axios';

export function App() {
  useEffect(() => {
    // A global 401 (outside login/me) clears the session; ProtectedRoute then
    // redirects to /login. Keeps auth logic out of components.
    setUnauthorizedHandler(() => useAuthStore.getState().clearSession());
    // Restore the session on boot (GET /api/auth/me).
    void useAuthStore.getState().bootstrap();
    return () => setUnauthorizedHandler(null);
  }, []);

  return <AppRouter />;
}
